<template>
	<section>
		<div class="row">
			<div class="col" style="max-width:400px;">
				<div class="list-pengiriman">
					<div class="row">
						<div class="col align-self-center">
							<p class="mb-0"><b>List Pengiriman</b></p>
						</div>
						<div class="col text-right">
							<div class="dropdown">
								<button class="btn btn-sm bg-white text-warning p-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
									<span v-if="status == ''">Semua</span>
									<span v-if="status == 1">Dalam Proses</span>
									<span v-if="status == 2">Menunggu Pickup</span>
									<span v-if="status == 3">Pickup Driver</span>
									<span v-if="status == 4">Dalam Pengiriman</span>
									<span v-if="status == 5">Selesai Diterima</span>
									
									&nbsp;<i class="fa fa-chevron-down"></i>
								</button>
								<div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
									<span class="pointer dropdown-item" @click="status = ''">Semua</span>
									<div class="dropdown-divider"></div>
									<span class="pointer dropdown-item" @click="status = 1">Dalam Proses</span>
									<div class="dropdown-divider"></div>
									<span class="pointer dropdown-item" @click="status = 2">Menunggu Pickup</span>
									<div class="dropdown-divider"></div>
									<span class="pointer dropdown-item" @click="status = 3">Pickup Driver</span>
									<div class="dropdown-divider"></div>
									<span class="pointer dropdown-item" @click="status = 4">Dalam Pengiriman</span>
									<div class="dropdown-divider"></div>
									<span class="pointer dropdown-item" @click="status = 5">Selesai Diterima</span>
								</div>
							</div>
						</div>
					</div>
					<div class="input-group mt-2 mb-3">
						<div class="input-group-prepend">
							<span class="input-group-text"><i class="fa fa-search f-16 ml-1 text-secondary"></i></span>
						</div>
						<input type="text" class="form-control border-left-0 pl-0" placeholder="Cari" v-model="search">
					</div>
					<section v-if="shippings.length == 0">
						<div class="vertical-center">
							<img src="/img/no-shipping.png" alt="">
							<p class="mt-4 text-secondary">Tidak ada pengiriman</p>
							<button class="btn btn-primary" @click="$router.push('/my-order/add')">Buat Pengiriman Baru</button>
						</div>
					</section>
					<section v-else>
						<div 
							v-for="shipping in shippings" :key="shipping.id"
							@click="shipping_detail = shipping" 
							:class="shipping_detail && shipping_detail.id == shipping.id ? 'active-order' : ''"
							class="card mb-3 pointer data-pengiriman d-none d-lg-block">
							<div class="card-body p-3">
								<div class="row pl-3">
									<span class="info" :class="
										shipping.col_status == 'Dalam Proses' ? 'warning' :
										shipping.col_status == 'Menunggu Pickup' ? 'wait' :
										shipping.col_status == 'Pickup Driver' ? 'pickup' :
										shipping.col_status == 'Dalam Pengiriman' ? 'infoo' :
										shipping.col_status == 'Selesai Diterima' ? 'success' :
										'warning'">
										{{ shipping.col_status }}
									</span>
									<div class="col m-0 text-right">
										<small class="text-secondary">{{shipping.no_resi}}</small>
									</div>
								</div>
								<hr style="border-style: dashed">
								<div class="row pl-3">
									<img src="/img/fa-solid_map-marker-alt-green.png" alt="" style="height: fit-content" class="mt-2 mr-2">
									<div class="col">
										<p class="mb-0 f-14"><b>{{shipping.penerima.name}} - {{shipping.penerima.phone_number}}</b></p>
										<p class="text-secondary mb-0 f-14">
											{{shipping.penerima.address}},
											{{shipping.penerima.location.kabupaten}},
											{{shipping.penerima.location.provinsi}},
											{{shipping.penerima.zipcode.kodepos}}
										</p>
									</div>
								</div>
							</div>
						</div>
						<div 
							v-for="shipping in shippings" :key="shipping.id"
							@click="shipping_detail = shipping" 
							:class="shipping_detail && shipping_detail.id == shipping.id ? 'active-order' : ''"
							class="card mb-3 pointer data-pengiriman d-lg-none"
							data-toggle="modal" data-target="#detailPengiriman">
							<div class="card-body p-3">
								<div class="row pl-3">
									<span class="info" :class="
										shipping.col_status == 'Dalam Proses' ? 'warning' :
										shipping.col_status == 'Menunggu Pickup' ? 'wait' :
										shipping.col_status == 'Pickup Driver' ? 'pickup' :
										shipping.col_status == 'Dalam Pengiriman' ? 'infoo' :
										shipping.col_status == 'Selesai Diterima' ? 'success' :
										'warning'">
										{{ shipping.col_status }}
									</span>
									<div class="col m-0 text-right">
										<small class="text-secondary">{{shipping.no_resi}}</small>
									</div>
								</div>
								<hr style="border-style: dashed">
								<div class="row pl-3">
									<img src="/img/fa-solid_map-marker-alt-green.png" alt="" style="height: fit-content" class="mt-2 mr-2">
									<div class="col">
										<p class="mb-0 f-14"><b>{{shipping.penerima.name}} - {{shipping.penerima.phone_number}}</b></p>
										<p class="text-secondary mb-0 f-14">
											{{shipping.penerima.address}},
											{{shipping.penerima.location.kabupaten}},
											{{shipping.penerima.location.provinsi}},
											{{shipping.penerima.zipcode.kodepos}}
										</p>
									</div>
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
			<div class="col pl-0 d-lg-block d-none">
				<div class="detail-pengiriman">
					<section v-if="shipping_detail == null">
						<div class="vertical-center" v-if="shippings.length == 0">
							<img src="/img/no-shipping-2.png" alt="">
							<p class="mt-4 text-secondary">Pengiriman jadi cepat dan mudah dengan Bisa Cek</p>
						</div>
						<div class="vertical-center" v-else>
							<img src="/img/no-shipping-3.png" alt="">
							<p class="mt-4 text-secondary">Pilih pengiriman yang ingin Anda tampilkan</p>
						</div>
					</section>
					<section v-else>
						<div class="row pl-3">
							<span class="info" :class="
								shipping_detail.col_status == 'Dalam Proses' ? 'warning' :
								shipping_detail.col_status == 'Menunggu Pickup' ? 'wait' :
								shipping_detail.col_status == 'Pickup Driver' ? 'pickup' :
								shipping_detail.col_status == 'Dalam Pengiriman' ? 'infoo' :
								shipping_detail.col_status == 'Selesai Diterima' ? 'success' :
								'warning'">
								{{ shipping_detail.col_status }}
							</span>
							<div class="col text-right">
								<small class="text-secondary">{{ shipping_detail.updated_at | moment('D MMMM YYYY')}}</small>
							</div>
						</div>
						<hr style="border-style: dashed">
						<small class="text-secondary">No. Resi</small>
						<p class="f-14">{{ shipping_detail.no_resi }}</p>
						<div class="col text-center">
							<img src="/img/milestone-waiting-payment.png" alt="" class="img-fluid mt-2 pl-2 pr-2" v-if="shipping_detail.col_status == 'waiting-payment'">
							<img src="/img/milestone-dalam-proses.png" alt="" class="img-fluid mt-2 pl-2 pr-2" v-if="shipping_detail.col_status == 'Dalam Proses' || shipping_detail.col_status == 'Pickup Driver'">
							<img src="/img/milestone-dalam-pengiriman.png" alt="" class="img-fluid mt-2 pl-2 pr-2" v-if="shipping_detail.col_status == 'Dalam Pengiriman'">
							<img src="/img/milestone-selesai.png" alt="" class="img-fluid mt-2 pl-2 pr-2" v-if="shipping_detail.col_status == 'Selesai Diterima'">
						</div>
						<p class="f-14 mt-2"><b>Pengiriman Detail</b></p>
						<small class="text-secondary">Tipe Pengiriman</small>
						<p class="f-16" v-if="shipping_detail.type == 1">
							Kg <small>(Pengiriman berdasarkan berat)</small> <!-- | Loose Load -->
						</p>
						<p class="f-16" v-else>
							Box <small>(Pengiriman berdasarkan jumlah box)</small> <!-- | Loose Load -->
						</p>
						<div class="row">
							<div class="col">
								<div class="row pl-3">
									<img src="/img/fa-solid_map-marker-alt.png" alt="" style="height: fit-content" class="mt-2 mr-2">
									<div class="col">
										<p class="mb-0 f-14"><b>{{shipping_detail.pengirim.name}} - {{shipping_detail.pengirim.phone_number}}</b></p>
										<p class="text-secondary mb-0 f-14">
											{{shipping_detail.pengirim.address}},
											{{shipping_detail.pengirim.location.kabupaten}},
											{{shipping_detail.pengirim.location.provinsi}},
											{{shipping_detail.pengirim.zipcode.kodepos}}
										</p>
									</div>
								</div>
							</div>
							<img src="/img/green-arrow.png" alt="" class="img-fluid align-self-center">
							<div class="col">
								<div class="row pl-3">
									<img src="/img/fa-solid_map-marker-alt-green.png" alt="" style="height: fit-content" class="mt-2 mr-2">
									<div class="col">
										<p class="mb-0 f-14"><b>{{shipping_detail.penerima.name}} - {{shipping_detail.penerima.phone_number}}</b></p>
										<p class="text-secondary mb-0 f-14">
											{{shipping_detail.penerima.address}},
											{{shipping_detail.penerima.location.kabupaten}},
											{{shipping_detail.penerima.location.provinsi}},
											{{shipping_detail.penerima.zipcode.kodepos}}
										</p>
									</div>
								</div>
							</div>
						</div>
						<hr>
						<p class="f-14 mt-2"><b>Informasi Produk</b></p>
						<small class="text-secondary">Catatan</small><br>
						<small><i>{{shipping_detail.keterangan}}</i></small>
						<hr>
						<p class="f-14 mt-2"><b>Informasi Produk</b></p>
						<div class="row pl-3 mb-2" v-for="product in shipping_detail.barang" :key="product.id">
							<img src="/img/product.png" alt="" style="height: fit-content" class="mt-2 mr-2">
							<div class="col">
								<label for="" class="f-12">Produk</label>
								<div class="row">
									<div class="col f-14"><b>{{product.name}}</b></div>
									<div class="col text-right f-14"><b>{{product.weight}} Kg</b></div>
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
		</div>

		<div class="modal fade d-lg-none" id="detailPengiriman" v-if="shipping_detail != null">
		    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
		        <div class="modal-content mx-auto">
					<div class="modal-body">                
						<p class="f-14 f-m-12"><b>Detail</b>   
							<button type="button" class="close float-right" data-dismiss="modal" aria-label="Close" @click="shipping_detail = null">
								<span aria-hidden="true">&times;</span>
							</button>
						</p>
						<div class="row pl-3">
							<span class="info" :class="
								shipping_detail.col_status == 'Dalam Proses' ? 'warning' :
								shipping_detail.col_status == 'Menunggu Pickup' ? 'wait' :
								shipping_detail.col_status == 'Pickup Driver' ? 'pickup' :
								shipping_detail.col_status == 'Dalam Pengiriman' ? 'infoo' :
								shipping_detail.col_status == 'Selesai Diterima' ? 'success' :
								'warning'">
								{{ shipping_detail.col_status }}
							</span>
							<div class="col text-right">
								<small class="text-secondary">{{ shipping_detail.updated_at | moment('D MMMM YYYY')}}</small>
							</div>
						</div>
						<hr style="border-style: dashed">
						<small class="text-secondary">No. Resi</small>
						<p class="f-14">{{ shipping_detail.no_resi }}</p>
						<div class="col text-center">
							<img src="/img/milestone-waiting-payment.png" alt="" class="img-fluid mt-2 pl-2 pr-2" v-if="shipping_detail.col_status == 'waiting-payment'">
							<img src="/img/milestone-dalam-proses.png" alt="" class="img-fluid mt-2 pl-2 pr-2" v-if="shipping_detail.col_status == 'Dalam Proses' || shipping_detail.col_status == 'Pickup Driver'">
							<img src="/img/milestone-dalam-pengiriman.png" alt="" class="img-fluid mt-2 pl-2 pr-2" v-if="shipping_detail.col_status == 'Dalam Pengiriman'">
							<img src="/img/milestone-selesai.png" alt="" class="img-fluid mt-2 pl-2 pr-2" v-if="shipping_detail.col_status == 'Selesai Diterima'">
						</div>
						<p class="f-14 mt-2"><b>Pengiriman Detail</b></p>
						<small class="text-secondary">Tipe Pengiriman</small>
						<p class="f-16" v-if="shipping_detail.type == 1">
							Kg <small>(Pengiriman berdasarkan berat)</small> <!-- | Loose Load -->
						</p>
						<p class="f-16" v-else>
							Box <small>(Pengiriman berdasarkan jumlah box)</small> <!-- | Loose Load -->
						</p>
						<div class="row">
							<div class="col">
								<div class="row pl-3">
									<img src="/img/fa-solid_map-marker-alt.png" alt="" style="height: fit-content" class="mt-2 mr-2">
									<div class="col">
										<p class="mb-0 f-14"><b>{{shipping_detail.pengirim.name}} - {{shipping_detail.pengirim.phone_number}}</b></p>
										<p class="text-secondary mb-0 f-14">
											{{shipping_detail.pengirim.address}},
											{{shipping_detail.pengirim.location.kabupaten}},
											{{shipping_detail.pengirim.location.provinsi}},
											{{shipping_detail.pengirim.zipcode.kodepos}}
										</p>
									</div>
								</div>
							</div>
							<img src="/img/green-arrow.png" alt="" class="img-fluid align-self-center">
							<div class="col">
								<div class="row pl-3">
									<img src="/img/fa-solid_map-marker-alt-green.png" alt="" style="height: fit-content" class="mt-2 mr-2">
									<div class="col">
										<p class="mb-0 f-14"><b>{{shipping_detail.penerima.name}} - {{shipping_detail.penerima.phone_number}}</b></p>
										<p class="text-secondary mb-0 f-14">
											{{shipping_detail.penerima.address}},
											{{shipping_detail.penerima.location.kabupaten}},
											{{shipping_detail.penerima.location.provinsi}},
											{{shipping_detail.penerima.zipcode.kodepos}}
										</p>
									</div>
								</div>
							</div>
						</div>
						<hr>
						<p class="f-14 mt-2"><b>Informasi Produk</b></p>
						<small class="text-secondary">Catatan</small><br>
						<small><i>{{shipping_detail.keterangan}}</i></small>
						<hr>
						<p class="f-14 mt-2"><b>Informasi Produk</b></p>
						<div class="row pl-3 mb-2" v-for="product in shipping_detail.barang" :key="product.id">
							<img src="/img/product.png" alt="" style="height: fit-content" class="mt-2 mr-2">
							<div class="col">
								<label for="" class="f-12">Produk</label>
								<div class="row">
									<div class="col f-14"><b>{{product.name}}</b></div>
									<div class="col text-right f-14"><b>{{product.weight}} Kg</b></div>
								</div>
							</div>
						</div>
					</div>
		        </div>
		    </div>
		</div>
	</section>
</template>
<script>
export default {
	data() {
		return {
			shippings: [],
			shipping_detail: null,
			search: '',
			status: ''
		}
	},
	methods: {
		index()
		{
			let _ = this
			_.axios.get('/shipment/customer?key=' + _.search + '&status=' + _.status)
				.then( resp => {
					// resp.data.data.data.forEach(elm => {
					// 	_.shippings.push(elm)
					// })
					_.shippings = resp.data.data
					_.$root.$emit('total_shipping', _.shippings.length)
				})
		}
	},
	mounted() {
		let _ = this
		_.index()
	},
	watch: {
		search: function()
		{
			// this.shippings = []
			this.index()
		},
		status: function()
		{
			// this.shippings = []
			this.index()
		}
	}
}
</script>